$(function () {
	$(".cart-toggle").on("click", function () {
		$(".mini-cart-popup").toggleClass("open");
		$(".mini-cart-backdrop").fadeToggle();
	});
	$(".btn-close-cart").on("click", function () {
		$(".mini-cart-popup").removeClass("open");
		$(".mini-cart-backdrop").fadeOut();
	});
});
